import { getPath, pageNames } from '@atc/bonnet-paths';

import { isPsxDemTraffic, isVDPExperienceUTM } from './utils/utmTrafficClassifiers';

export default function withInventoryPageRedirect() {
    return async (ctx, next) => {

        const {
            extended_hybrid_vdp: [enableExtendedHybridVdp],
        } = ctx.useFeatures([
            'extended_hybrid_vdp',
        ]);

        // Case 1: If the VDP returns no results, redirect the user to the SRP.
        // Case 2: If the user navigates to the VDP via the SRP, and the VDP LSC fails to retrieve data (ctx.res is undefined), display the VDP with limited information from the SRP response and an alert message.
        const query = { ...ctx.query };

        if (isVDPExperienceUTM(query)) {
            // Redirect PSX Marketing traffic to hybrid VDP
            if (enableExtendedHybridVdp && isPsxDemTraffic(query) && ctx?.res) {
                const statusCode = 301;

                const invPath = await getPath(pageNames.INVENTORY_DETAILS, query, {});

                ctx.res.redirect(statusCode, invPath);
                ctx.res.end();
                ctx.statusCode = statusCode;

                return next('server redirect');
            }
        }

        return next();
    };
}
